const ACTION_PREFIX = '@komigen/mobile-frontend/casino';

export const FETCH_CASINO_GAMES_START = `${ACTION_PREFIX}/FETCH_CASINO_GAMES_START`;

export const HYDRATE_CASINO_GAMES = `${ACTION_PREFIX}/HYDRATE_CASINO_GAMES`;

export const PREVIOUS_LOCATION = `${ACTION_PREFIX}/PREVIOUS_LOCATION`;

export const EXPLORE_CASINO_PROCESS = `${ACTION_PREFIX}/EXPLORE_CASINO_PROCESS`;

export const INVALIDATE_CASINO_DATA = `${ACTION_PREFIX}/INVALIDATE_CASINO_DATA`;

export const SET_QUICK_FILTERS_POSITION = `${ACTION_PREFIX}/SET_QUICK_FILTERS_POSITION`;

export const RESET_CASINO_EXPLORE_STATUS = `${ACTION_PREFIX}/RESET_CASINO_EXPLORE_STATUS`;
